import {Route, Routes} from '@angular/router';

export const routes: Routes = [

  // 👇 ❌ Introduce Route + Possible Layout Module

  <Route>{ path: '', loadChildren: () => import('./views/main/main.module').then(m => m.MainModule) },
  <Route>{ path: 'main', loadChildren: () => import('./views/main/main.module').then(m => m.MainModule) },

];
